class CollectionFilter extends HTMLElement {
  constructor() {
    super();
    console.log("CollectionFilter: Constructor initialized");
    this.filtersContainer = null;
    this.filterCheckboxes = null;
    this.productGridContainer = null;
    this.paginationContainer = null;
    this.loaderContainer = null;


  }

  connectedCallback() {
    console.log("connectedCallback: Component connected to the DOM");
    this.setupElements();
    this.bindEvents();
    this.setupListeners()
  }

  setupElements() {
    console.log("setupElements: Setting up DOM elements");
    this.filtersContainer = this.querySelector(".filters-list");
    this.filterCheckboxes = this.querySelectorAll(".js-filter");
    this.productGridContainer = document.getElementById("product-grid");
    this.paginationContainer = document.getElementById("PaginationContainer");
    this.loaderContainer = document.querySelector("#loaderContainer");
  }
  setupListeners() {
    console.log("setupListeners")
    // Handle filter toggle
    const filterToggle = document.getElementById("filter-toggle");
    filterToggle.addEventListener("click", () => {
      filterToggle.classList.toggle('active')
      this.toggleFilters();
    });



    const filterValuesToggle = document.querySelectorAll(".filter-item");
    filterValuesToggle.forEach((filterItem) => {
      filterItem.addEventListener("click", (event) => {

        this.toggleFiltersValues(event, filterValuesToggle);
      });
    });



  }

  toggleFiltersValues(event, filterValuesToggle) {
    filterValuesToggle.forEach((item) => {
       item.classList.remove("active");
     });

     // Hide all .filter-values elements
     const allFilterValues = document.querySelectorAll(".filter-values");
     allFilterValues.forEach((filterValues) => {
       filterValues.classList.add("hidden");
     });

    const filterItem = event.target.closest(".filter-item");
    if (!filterItem) return;
    filterItem.classList.toggle('active')

    const filterParam = filterItem.getAttribute("data-filter-param");
    if (!filterParam) return;

    console.log("Filter item clicked with param:", filterParam);

    const filtersContainer = document.querySelector(
      `[data-filter-param="${CSS.escape(filterParam)}"].filter-values`
    );

    if (filtersContainer) {
      filtersContainer.classList.toggle("hidden");
    } else {
      console.warn("Filters container not found for:", filterParam);
    }
  }


  bindEvents() {
    console.log("bindEvents: Binding event listeners", this.filterCheckboxes);
    this.filterCheckboxes.forEach((checkbox) => {
      console.log("bindEvents: Binding event listeners");

      checkbox.addEventListener("change", (event) => this.onFilterChange(event));
    });



    if (this.paginationContainer) {
      this.paginationContainer.addEventListener("click", (e) => {
        console.log("bindEvents: Pagination link clicked");
        const link = e.target.closest("a");
        if (link) {
          e.preventDefault();
          const url = new URL(link.href);
          this.fetchAndRender(url.toString());
        }
      });
    }
  }
  toggleFilters() {
    console.log("toggleFilters: Toggling filter visibility");
    const filtersPanel = document.getElementById("filters-container");
    if (filtersPanel) {
      filtersPanel.classList.toggle("hidden"); // Add or remove the `hidden` class
    }
  }

  onFilterChange(event) {

    console.log("onFilterChange: Filter checkbox changed");
    const checkbox = event.target;
    console.log("Checkbox dataset:", checkbox.dataset);

    const isChecked = checkbox.checked;
    const filterParam = checkbox.dataset.filterParam;
    const filterValue = checkbox.dataset.filterValue;

    const url = new URL(window.location.href);
    url.searchParams.delete("page"); // Reset pagination to the first page

    const existingValues = url.searchParams.getAll(filterParam);

    if (isChecked) {
      console.log(`Adding filter: ${filterParam}=${filterValue}`);
      // Add the filter value only if it doesn't already exist
      if (!existingValues.includes(filterValue)) {
        url.searchParams.append(filterParam, filterValue);
      }
    } else {
      console.log(`Removing filter: ${filterParam}=${filterValue}`);
      // Remove the filter value if it exists
      const updatedValues = existingValues.filter((val) => val !== filterValue);
      url.searchParams.delete(filterParam);
      updatedValues.forEach((val) => {
        url.searchParams.append(filterParam, val);
      });
    }

    console.log("Updated URL:", url.toString());
    history.replaceState({}, "", url.toString());

    // Fetch and update the grid
    this.fetchAndRender(url.toString());
  }


  async fetchAndRender(url) {
    console.log("fetchAndRender: Fetching updated product grid");
    this.showLoader(true);

    const ajaxUrl = new URL(url);
    ajaxUrl.searchParams.set("view", "collection-grid");

    console.log(ajaxUrl)
    try {
      const response = await fetch(ajaxUrl.toString(), {
        method: "GET",
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const newGrid = doc.getElementById("product-grid");
      if (newGrid && this.productGridContainer) {
        console.log("fetchAndRender: Replacing product grid content");
        this.productGridContainer.innerHTML = newGrid.innerHTML;
      }

      const newPagination = doc.getElementById("PaginationContainer");
      if (newPagination && this.paginationContainer) {
        console.log("fetchAndRender: Replacing pagination content");
        this.paginationContainer.innerHTML = newPagination.innerHTML;
      }

    } catch (error) {
      console.error("fetchAndRender: Error fetching updated grid", error);
    } finally {
      this.showLoader(false);
    }
  }

  showLoader(show) {
    console.log(`showLoader: Loader visibility set to ${show}`);
    if (!this.loaderContainer) return;
    this.loaderContainer.style.display = show ? "block" : "none";
  }
}

// Register the custom element
customElements.define("collection-filter", CollectionFilter);
